import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/service/auth.service';
import { RestClientService } from 'src/app/core/service/rest-client.service';
import { UtilitiesService } from 'src/app/core/service/utilities.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-parametre-fournisseur',
  templateUrl: './parametre-fournisseur.component.html',
  styleUrls: ['./parametre-fournisseur.component.scss']
})
export class ParametreFournisseurComponent implements OnInit {
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint : string = 'pharmacieFournisseur/';
  itemsTypeFournisseurs: any;
  itemsCategrieClient: any;

  constructor(private authService: AuthService, private restClient: RestClientService, private modalService: BsModalService, private utilities: UtilitiesService) {
    this.user = this.authService.currentUserValue;
  }

  pageChanged(event: any): void {
    this.currentPage = event.page ;
    this.getItems();
  }

  changePaginationSize($event) {
    if($event) {
      this.currentPage = 1;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }

  confirmSaveItem(item) {

    let objToSave = Object.assign({}, item);

    if (!item.nomPersonneAContacter) {
      this.utilities.showNotification("snackbar-danger", "Veuillez renseigner le nom de la personne à contacter !",
        "bottom",
        "center");
      return;
    }

    if (!item.numeroPersonneAContacter) {
      this.utilities.showNotification("snackbar-danger", "Veuillez renseigner le numéro de la personne à contacter !",
        "bottom",
        "center");
      return;
    }

    if (!item || !item.typeFournisseurId) {
      this.utilities.showNotification("snackbar-danger", "Veuillez sélectionner le type fournisseur !",
        "bottom",
        "center");
      return;
    }


    Swal.fire({
      title: "Fournisseur",
      text: objToSave?.id ? "Vous êtes sur le point de modifier un fournisseur. Voulez-vous poursuivre cette action ?" : "Vous êtes sur le point d'enregistrer un fournisseur. Voulez-vous poursuivre cette action ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }

  openModal(data: any, template: TemplateRef<any>) {

    let config = {backdrop: true, ignoreBackdropClick: true,id: 1, class: 'modal-lg'};

    this.itemToSave = {};
    if (data) {
      // Lorsque nous sommes en modification
      this.itemToSave = Object.assign({}, data);
    }

    this.modalRef = this.modalService.show(template,config);
  }

  saveItem(item) {

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);

    var request = {
      user: this.user.id,
      datas: [
        itemAEnregistrer
      ]
    }

    this.busySave = this.restClient.post(this.endPoint+''+ (itemAEnregistrer.id ? 'update' : 'create'), request)
      .subscribe(
        res => {
          console.log("resul", res);
          this.loading = false;

          if (!res['hasError']) {
            if (res['items'] && res['items'].length > 0) {

              this.utilities.showNotification("snackbar-success",
                this.utilities.formatMsgServeur(res['status']['message']),
                "bottom",
                "center");

              this.getItems();
              this.modalRef.hide();
            }
          } else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification("snackbar-danger",
                this.utilities.formatMsgServeur(res['status']['message']),
                "bottom",
                "center");
            }
          }
        },
        err => {
          this.utilities.showNotification("snackbar-danger", this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center");
          this.loading = false;
        }
      );
  }

  getItems() {
    let request = {
      user: this.user.id,
      data: {
        nom: this.itemToSearch.libelle ? this.itemToSearch.libelle : null
      },
      index: (this.currentPage - 1),
      size: this.itemsPerPage
    }

    this.busyGet = this.restClient.post(this.endPoint+'/getByCriteria', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.items = res['items'];
            this.totalItems = res['count'];
            console.log( this.items);

          }
          else {
            this.items = [];
            this.totalItems = 0;
          }
        },
        err => {
        }
      );
  }

  getItemsTypeFournisseur() {
    console.log('getting data');
    let request = {
      user: this.user.id,
      data: {

      },
    }

    this.busyGet = this.restClient.post('pharmacieTypeFournisseur/getByCriteria', request)
      .subscribe(
        res => {
          console.log('pharmacieTypeFournisseur',res);

          if (res && res['items']) {
            this.itemsTypeFournisseurs = res['items'];

          }
          else {
            this.itemsTypeFournisseurs = [];
          }
        },
        err => {
        }
      );
  }

  getItemsCategorieClient() {
    console.log('getting data');
    let request = {
      user: this.user.id,
      data: {

      },
    }

    this.busyGet = this.restClient.post('adminCategorieClient/getByCriteria', request)
      .subscribe(
        res => {
          console.log('itemsCategrieClient',res);

          if (res && res['items']) {
            this.itemsCategrieClient = res['items'];

          }
          else {
            this.itemsCategrieClient = [];
          }
        },
        err => {
        }
      );
  }

  confirmDelete(item){
    Swal.fire({
      title: "Fournisseur",
      text: "Vous êtes sur le point de supprimer ce fournisseur. Voulez-vous poursuivre cette action ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3f51b5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.deleteItem(item);
      }
    });
  };

  deleteItem(obj) {

    var request = {
      user: this.user.id,
      datas: [
        obj
      ]
    }

    this.busyGet = this.restClient.post(this.endPoint+'delete', request)
      .subscribe(
        res => {
          console.log(res);
          if (!res['hasError']) {
            this.utilities.showNotification("snackbar-success",
              this.utilities.formatMsgServeur(res['status']['message']),
              "bottom",
              "center");

            this.currentPage = 1;
            this.getItems();
          }
          else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification("snackbar-danger",
                this.utilities.formatMsgServeur(res['status']['message']),
                "bottom",
                "center");
            }
          }

        },
        err => {
          console.log("Error occured", err);
          this.utilities.showNotification("snackbar-danger", this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center");
        }
      );
  }

  ngOnInit() {
    this.getItems();
    this.getItemsTypeFournisseur()

  }
}
